<script setup>
import Menu from "./ListItemMenu.vue";
import { useConfig, useMenu } from "@/plugins/obscore.js";

const config = useConfig()
const menu = useMenu()
const emit = defineEmits(['hovering'])
const setHovering=function(hover){
    emit("hovering",hover)
}
</script>
<template>
  <v-navigation-drawer app v-bind="config.sidebar.drawer" @mouseenter="setHovering(true)" @mouseleave="setHovering(false)">
    <v-list v-bind="config.sidebar.list">
      <slot name="header">
      </slot>
      <slot name="default">
        <Menu v-for="(_menu, i) in menu" :key="i" v-bind="_menu" />
      </slot>
      <slot name="footer">
      </slot>
    </v-list>
  </v-navigation-drawer>
</template>
<style>
.v-navigation-drawer--expand-on-hover .v-list--nav {
    overflow-x: hidden;
}
.v-navigation-drawer--expand-on-hover:not(.v-navigation-drawer--is-hovering) .v-list-group__items .v-list-item {
    -webkit-padding-start: 0px !important;
    padding-inline-start: 0px !important;
    -webkit-padding-end: 0px !important;
    padding-inline-end: 0px !important;  
    font-size: .7rem;
}
</style>